// Application Configuration
export const APP_CONFIG = {
  name: 'W2W Legal',
  version: '0.0.1',

  // Pagination defaults
  pagination: {
    defaultPage: 1,
    defaultLimit: 10,
    limitOptions: [10, 25, 50, 100],
  },

  // Date formats
  dateFormats: {
    display: 'MMM dd, yyyy',
    displayWithTime: 'MMM dd, yyyy HH:mm',
    input: 'yyyy-MM-dd',
    api: "yyyy-MM-dd'T'HH:mm:ss.SSSxxx",
  },

  // Currency
  currency: {
    default: 'USD',
    locale: 'en-US',
  },

  // Debounce delays (ms)
  debounce: {
    search: 300,
    resize: 150,
    input: 200,
  },

  // Toast durations (ms)
  toast: {
    success: 3000,
    error: 5000,
    info: 4000,
  },

  // File upload
  upload: {
    maxSize: 10 * 1024 * 1024, // 10MB
    allowedTypes: ['image/jpeg', 'image/png', 'image/gif', 'application/pdf'],
  },
} as const;
